export default __webpack_public_path__ + "static/media/result.f94d1bf4.svg";